import { BasePersonnelModel } from './personnel.model';
import { Exclude, Expose } from 'class-transformer';
import { Default } from '@core/util';
import { Method, PersonnelRelationship } from '@core/data-access';

@Exclude()
export class BeneficialOwnerModel extends BasePersonnelModel {
  /**
   * Using in Dropdown
   */
  @Expose({ toClassOnly: true }) @Default(null) personnel_uuid!: string | null;

  /**
   * Using to Show/Hide Form Field
   */
  @Expose({ toClassOnly: true }) @Default(Method.manual) method!: Method | null;

  @Expose() keyPersonnelId!: number | null;

  @Expose() nationalityId!: number;

  @Expose() @Default(false) dualNationality!: boolean;

  @Expose() dualNationalityId!: number;

  @Expose() @Default([]) relationshipToApplicant!: PersonnelRelationship[];

  @Expose() relationshipToApplicantOther!: string;
}
